import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import Styles from './vm-kol-profile-stat-box.scss';

@customElement('vm-kol-profile-stat-box')
export class VmKolProfileStatBox extends LitElement {
    static override styles = Styles;

    @property({ type: Number }) value = 0;
    @property({ type: String }) label = '';
    @property({ type: Boolean }) compact = false;

    private get displayValue(): string {
        const num = Number(this.value);
        if (isNaN(num)) return '';
        if (!this.compact || num === 0) return `${num}`;
        if (num < 1000) return `${num}+`;
        return `${Math.floor(num / 1000)}k+`;
    }

    override render() {
        return html`
            <span class="stat-box__value">${this.displayValue}</span>
            <span class="stat-box__label">${this.label}</span>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-kol-profile-stat-box': VmKolProfileStatBox;
    }
}
